import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime'
})
export class FormatTimePipe implements PipeTransform {

  transform(minutes: number): string {
    const days = Math.floor(minutes / (60 * 24));
    const hours = Math.floor((minutes % (60 * 24)) / 60);
    const remainingMinutes = minutes % 60;

    let result = '';
    if (days > 0) {
      result += `(+${days} d) `;
    }
    result += `${hours}h:${remainingMinutes}m`;

    return result;
  }
}
